import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class SucursalService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerTodos(callback) {
        this.gqlclient.query({
            query: gql `
        {
          sucursal {
            obtenerTodos {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                registros {
                  rut_empresa
                  codigo
                  nombre
                  descripcion
                  activo
                  fecha_creacion
                }
              }
            }
          }
        }        
        `,
            variables: {},
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.sucursal.obtenerTodos;
            callback({ mensajes, respuesta });
        });
    }
    obtenerSucursalxEmpresa(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($rut_empresa: Decimal) {
          sucursal {
            obtenerSucursalxEmpresa(rut_empresa: $rut_empresa) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                registros {
                  rut_empresa
                  codigo
                  nombre
                  descripcion
                  activo
                  fecha_creacion
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.sucursal.obtenerSucursalxEmpresa;
            callback({ mensajes, respuesta });
        });
    }
}
SucursalService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SucursalService_Factory() { return new SucursalService(i0.ɵɵinject(i1.GraphQLClient)); }, token: SucursalService, providedIn: "root" });
